import en from "./dictionaries/en";
import fr from "./dictionaries/fr";
import es from "./dictionaries/es";
import ar from "./dictionaries/ar";

export const DICTS = { en, fr, es, ar } as const;
export type Locale = keyof typeof DICTS;
export type Dict = typeof en;

export function normalizeLocale(x?: string | null): Locale {
  const v = String(x || "").toLowerCase();
  if (v === "fr") return "fr";
  if (v === "ar") return "ar";
  if (v === "en") return "en";
  return "es";
}

export function getDictionary(locale?: string | null): Dict {
  return DICTS[normalizeLocale(locale)];
}

export function isRTL(locale?: string | null) {
  return normalizeLocale(locale) === "ar";
}
